import { useEffect, useState, createContext, useContext, useMemo } from "react";

import {
  Button,
  IconButton,
  TextField,
  InputAdornment,
  Autocomplete,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import Modal from "@mui/material/Modal";
import GrassIcon from "@mui/icons-material/Grass";
import Paper from "@mui/material/Paper";
import request from "../../../../../Helpers/API";
import MenuItem from "@mui/material/MenuItem";
import { Context } from "../DashCrearSolicitudCredito";
import Swal from "sweetalert2";
import { GetArrKey, GetKey } from "../../../../../Helpers/GetKey";
import { FormatMoney } from "../../../../../Helpers/FormatNumber";
import { ValFormReg } from "../../../../../Validators/ValForms";
import { RegularExpressions } from "../../../../../Helpers/RegularExpression";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { Moneda } from "../../../../../Helpers/Moneda";
import { useHistory } from "react-router-dom";
import { Decimal } from "../../../../../Helpers/Moneda";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

// Creación de un contexto para los cultivos
const contextCultivos = createContext(null);

// Componente principal de la solicitud de crédito para los cultivos
export default function SoliciitudDeCreditoCultivos({
  onNext,
  loader,
  setLoader,
  screen,
  setScreen,
  setValue,
  setBotonSiguiente,
}) {
  const history = useHistory();
  // Utilizamos el contexto de la solicitud de crédito
  const { state } = useContext(Context);
  const [cultivos, setCultivos] = useState([]);
  // Estado local para los cultivos
  const [stateCultivos, setStateCultivos] = useState({
    open: false,
    meses: {
      Enero: 1,
      Febrero: 2,
      Marzo: 3,
      Abril: 4,
      Mayo: 5,
      Junio: 6,
      Julio: 7,
      Agosto: 8,
      Septiembre: 9,
      Octubre: 10,
      Noviembre: 11,
      Diciembre: 12,
    },
    tipo_riego: {
      Bombeo: "B",
      Goteo: "G",
      Rodado: "R",
    },
    temporal: {
      Si: "S",
      No: "N",
    },
    seguro_cosecha: {
      Si: "S",
      No: "N",
      Compañia: "C",
    },
    cultivosDropdown: [],
    formDatos: {
      idsolicitud_cultivo: -1,
      idcultivo: 0,
      nombre: "",
      hectareas: "",
      rendimiento: "",
      total_toneladas: "",
      precio: "",
      tipo_riego: "",
      temporal: "",
      ciclo: "",
      terreno: "",
      seguro_cosecha: "",
      mescosecha: "",
    },
  });

  // Función para abrir el modal de edición de un cultivo
  // const openEditarCultivo = (cultivo) => {

  //   setStateCultivos({
  //     ...stateCultivos,
  //     open: true,
  //   });
  // };

  // Función para abrir el modal de edición de un cultivo
  const editarCultivo = (registro) => {
    request
      .get(
        `ClientesCultivo/ObtenerporOrden?idcliente=${state.idCliente}&registro=${registro}`
      )
      .then((result) => {
        const tipoRiegoInicial = result.tipo_riego;
        const tipoRiegoModificado = tipoRiegoInicial.charAt(0);

        const seguroCosechaInicial = result.seguro_cosecha;
        const seguroCosechaModificado = seguroCosechaInicial.charAt(0);

        const temporalInicial = result.temporal;
        const temporalModificado = temporalInicial.charAt(0);

        const terrenoInicial = result.terreno;
        const terrenoModificado = terrenoInicial.charAt(0);

        const mesCosechaInicial = result.mescosecha;
        const mesCosechaModificado = mesCosechaInicial.substring(0, 2);

        setStateCultivos({
          ...stateCultivos,
          open: true,
          formDatos: {
            idcultivo: result.idcultivo,
            nombre: result.cultivo,
            terreno: terrenoModificado,
            hectareas: result.hectareas,
            seguro_cosecha: seguroCosechaModificado,
            ciclo: result.ciclo,
            tipo_riego: tipoRiegoModificado,
            temporal: temporalModificado,
            rendimiento: result.rendimiento,
            precio: result.precio,
            mescosecha: mesCosechaModificado,
            idcliente: state.idCliente,
            registro: result.registro,
          },
        });
      })
      .catch((error) => {
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };
  useEffect(() => {
    setBotonSiguiente(() => (
      <div
        className="footer-solicitud-credito-guardar"
        onClick={() => {
          // Se conservan folio/idcliente para no perder el contexto de la solicitud al regresar
          history.push(
            "/DashClientes/solicitudcreditoGenerar",
            {
              vista: 0,
              folio: state.folio,
              idcliente: state.idCliente,
            }
          );
        }}
      >
        Siguiente <ArrowForwardIcon />
      </div>
    ));
  }, []);

  // Efecto para obtener la lista de cultivos al cargar el componente
  useEffect(() => {
    request.get("Cultivos/DropDownList").then((result) => {
      setStateCultivos((prevState) => ({
        ...prevState,
        cultivosDropdown: result,
      }));
    });
  }, []);
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ClientesCultivo/Listado?idcliente=${state.idCliente}`)
      .then((result) => {
        setCultivos(result);
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "SOLICITUD DE CREDITO",
          text: `${JSON.stringify(error)}`,
        });
        setLoader({ ...loader, mostrar: false });
      });
  }, []);
  // Función para abrir el modal de creación de un nuevo cultivo
  const openModal = () => {
    setStateCultivos({
      ...stateCultivos,
      open: true,
      formDatos: {
        idsolicitud_cultivo: -1,
        idcultivo: "",
        nombre: "",
        hectareas: "",
        rendimiento: "",
        total_toneladas: "",
        precio: "",
        tipo_riego: "",
        temporal: "",
        ciclo: "",
        terreno: "",
        seguro_cosecha: "",
        idcliente: state.idCliente,
        registro: -1,
        mescosecha: "",
        estatus: 1,
      },
    });
  };
  // Valor del contexto para los cultivos
  const contextValue = useMemo(
    () => ({
      stateCultivos,
      setStateCultivos,
    }),
    [stateCultivos, setStateCultivos]
  );

  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  };

  // Renderizado del componente
  return (
    <contextCultivos.Provider value={contextValue}>
      <Button
        onClick={openModal}
        startIcon={<AddIcon />}
        variant="contained"
        fullWidth
        style={{ marginBottom: 10 }}
      >
        Agregar cultivo
      </Button>

      <ModalAgregar
        setCultivos={setCultivos}
        loader={loader}
        setLoader={setLoader}
        screen={screen}
        setScreen={setScreen}
      />

      <div className="dash-clientes-container-table-cultivos scroll">
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <th>Cultivo</th>
              <th>Hectareas</th>
              <th>Rendimiento</th>
              <th>Mes Cosecha</th>
              <th>Precio</th>
              <th>Tipo de Riego</th>
              <th>Temporal</th>
              <th>
                <EditIcon />
              </th>
            </tr>
          </thead>
          <tbody>
            {cultivos === undefined ||
            cultivos === null ||
            cultivos.length === 0 ? (
              <></>
            ) : (
              cultivos.map((cultivo, i) => (
                <tr
                  key={i + 1}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <td>{capitalizeWords(cultivo.cultivo)}</td>
                  <td>{cultivo.hectareas}</td>
                  <td>{cultivo.rendimiento}</td>
                  <td>{capitalizeWords(cultivo.mescosecha)}</td>
                  <td style={{ textAlign: "end" }}>
                    $ {FormatMoney(cultivo.precio)}
                  </td>
                  <td>{capitalizeWords(cultivo.tipo_riego)}</td>
                  <td>{capitalizeWords(cultivo.temporal)}</td>
                  <td>
                    <IconButton
                      // onClick={() => {
                      //   openEditarCultivo(cultivo);
                      // }}
                      onClick={() => editarCultivo(cultivo.registro)}
                      color="warning"
                    >
                      <EditIcon />
                    </IconButton>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </contextCultivos.Provider>
  );
}

// Componente para el modal de agregar un nuevo cultivo
function ModalAgregar({ setCultivos, loader, setLoader, screen, setScreen }) {
  // Utilizamos el contexto de los cultivos y de la solicitud de crédito
  const { stateCultivos, setStateCultivos } = useContext(contextCultivos);
  const { state, setState } = useContext(Context);

  // Función para cerrar el modal
  const closeModal = () => {
    setStateCultivos({
      ...stateCultivos,
      open: false,
      formDatos: {
        idsolicitud_cultivo: -1,
        idcultivo: -8,
        nombre: "",
        hectareas: "",
        rendimiento: "",
        total_toneladas: "",
        precio: "",
        tipo_riego: "",
        temporal: "",
        ciclo: "",
        terreno: "",
        seguro_cosecha: "",
        idcliente: state.idCliente,
        registro: -1,
        mescosecha: "",
        estatus: 1,
      },
    });
  };

  // Función para recargar la tabla de cultivos
  const recargarTablaCultivos = () => {
    request
      .get(`ClientesCultivo/Listado?idcliente=${state.idCliente}`)
      .then((result) => {
        setCultivos(result);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "SOLICITUD DE CREDITO",
          text: `${JSON.stringify(error)}`,
        });
      });
  };

  // Función para agregar un nuevo cultivo
  const agregarCultivo = (datos) => {
    setLoader({ ...loader, mostrar: true });
    // Validar los campos utilizando las funciones de validación

    const cultivoValidation = ValFormReg(
      "Cultivo",
      datos.idcultivo,
      RegularExpressions.TextOnlyNumber
    );
    const hectareasValidation = ValFormReg(
      "Hectareas",
      datos.hectareas,
      RegularExpressions.TextOnlyNumber
    );
    const rendimientoValidation = ValFormReg(
      "Rendimiento",
      datos.rendimiento,
      RegularExpressions.TextOnlyNumber
    );
    // const totalToneladasValidation = ValFormReg(
    //   "Total Toneladas",
    //   datos.total_toneladas,
    //   RegularExpressions.TextOnlyNumber
    // );
    const cicloValidation = ValFormReg(
      "ciclo",
      datos.ciclo,
      RegularExpressions.TextAndNumber
    );
    const mesCosechaValidation = ValFormReg(
      "Mes de Cosecha",
      datos.mescosecha,
      RegularExpressions.TextOnlyNumber
    );
    const precioValidation = ValFormReg(
      "Precio",
      datos.precio,
      RegularExpressions.TextOnlyNumber
    );
    const tipoRiegoValidation = ValFormReg(
      "Tipo de Riego",
      datos.tipo_riego,
      RegularExpressions.TextWithSpace
    );
    const segurocosechaValidation = ValFormReg(
      "SEGURO DE COSECHA",
      datos.seguro_cosecha,
      RegularExpressions.TextWithSpace
    );
    const terrenoValidation = ValFormReg(
      "TERRENO",
      datos.terreno,
      RegularExpressions.TextWithSpace
    );
    // Verificar si alguna validación falla
    if (
      !cultivoValidation.isValid ||
      !hectareasValidation.isValid ||
      !rendimientoValidation.isValid ||
      !cicloValidation.isValid ||
      !mesCosechaValidation.isValid ||
      !precioValidation.isValid ||
      !tipoRiegoValidation.isValid ||
      !segurocosechaValidation.isValid ||
      !terrenoValidation.isValid
    ) {
      setLoader({ ...loader, mostrar: false });
      // Mostrar mensajes de error
      Swal.fire({
        icon: "error",
        title: "SOLICITUD DE CREDITO",
        html: `
          ${cultivoValidation.mensaje}
          ${hectareasValidation.mensaje}
          ${rendimientoValidation.mensaje}
          ${cicloValidation.mensaje}
          ${mesCosechaValidation.mensaje}
          ${precioValidation.mensaje}
          ${tipoRiegoValidation.mensaje}
          ${segurocosechaValidation.mensaje}
          ${terrenoValidation.mensaje}
        `,
      });
      return; // Detener la función si hay errores de validación
    }
    datos.folio = state.folio;
    datos.total_toneladas = Number(datos.hectareas) * Number(datos.rendimiento);
    request
      .post("ClientesCultivo", datos)
      .then(() => {
        recargarTablaCultivos();
      })
      .then(() => {
        setLoader({ ...loader, mostrar: false });
        closeModal();
        var habScreen = Number(screen) >= 4 ? screen : 3;
        setScreen(habScreen);
        Swal.fire({
          title: "SOLICITUD DE CREDITO",
          html: "Datos guardados con exito",
          icon: "success",
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("SOLICITUD DE CREDITO", JSON.stringify(error), "error");
      });
  };

  // Función para actualizar un campo del formulario
  const actualizarCampo = (event) => {
    const sinComas = event.target.value.replace(/,/g, "");
    setStateCultivos({
      ...stateCultivos,
      formDatos: {
        ...stateCultivos.formDatos,
        [event.target.name]: sinComas,
      },
    });
  };

  const onFocus = (e) => {
    e.target.type = "number";
  };
  const onBlur = (e, decimales = 2) => {
    e.target.type = "text";
    e.target.value = FormatMoney(
      Number(stateCultivos.formDatos[e.target.name]),
      decimales
    );
  };
  useEffect(() => {
    var hectareas = document.getElementById("hectareas");
    var rendimiento = document.getElementById("rendimiento");
    var precio = document.getElementById("precio");

    if (hectareas !== undefined && hectareas !== null)
      hectareas.value = FormatMoney(stateCultivos.formDatos.hectareas);

    if (rendimiento !== undefined && rendimiento !== null)
      rendimiento.value = FormatMoney(stateCultivos.formDatos.rendimiento);

    if (precio !== undefined && precio !== null)
      precio.value = FormatMoney(stateCultivos.formDatos.precio);
  }, [stateCultivos.formDatos.idsolicitud_cultivo]);

  // Renderizado del componente
  return (
    <Modal open={stateCultivos.open} className="position-z-index">
      <div className="dash-clientes-credito-crear-solicitud-modal">
        <div className="dash-clientes-credito-crear-solicitud-modal-header">
          <div className="dash-clientes-credito-crear-solicitud-modal-header-title">
            <GrassIcon />
            <div>
              {stateCultivos.formDatos.idsolicitud_cultivo === -1
                ? "AGREGAR NUEVO "
                : "EDITAR "}
              CULTIVO
            </div>
          </div>
          <div className="dash-clientes-credito-crear-solicitud-modal-header-efecto">
            <div className="dash-clientes-credito-crear-solicitud-modal-header-efecto-bl"></div>
            <div className="dash-clientes-credito-crear-solicitud-modal-header-efecto-circle"></div>
            <div className="dash-clientes-credito-crear-solicitud-modal-header-efecto-br"></div>
          </div>
        </div>
        <div className="dash-clientes-credito-crear-solicitud-form-container">
          <div className="full">
            <TextField
              fullWidth
              size="small"
              label="Cultivo"
              variant="outlined"
              name="idcultivo"
              select
              onChange={actualizarCampo}
              value={stateCultivos.formDatos.idcultivo}
            >
              {stateCultivos.cultivosDropdown.map((cultivo) => {
                return (
                  <MenuItem key={cultivo.id} value={cultivo.id}>
                    {cultivo.display}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>
          <TextField
            fullWidth
            size="small"
            label="Hectareas"
            variant="outlined"
            name="hectareas"
            id="hectareas"
            onChange={actualizarCampo}
            // onFocus={onFocus}
            // onBlur={onBlur}
            onKeyUp={(input) => Moneda(input.target)}
            value={stateCultivos.formDatos.hectareas}
            inputProps={{
              style: { textAlign: "right" },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <GrassIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            fullWidth
            size="small"
            label="Toneladas por Hectarea"
            variant="outlined"
            name="rendimiento"
            id="rendimiento"
            onChange={actualizarCampo}
            // onFocus={onFocus}
            // onBlur={onBlur}
            onKeyUp={(input) => Moneda(input.target)}
            value={stateCultivos.formDatos.rendimiento}
            inputProps={{
              style: { textAlign: "right" },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <GrassIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            fullWidth
            size="small"
            label="Total Toneladas"
            variant="outlined"
            name="total_toneladas"
            onChange={actualizarCampo}
            value={FormatMoney(
              Number(stateCultivos.formDatos.hectareas) *
                Number(stateCultivos.formDatos.rendimiento)
            )}
            inputProps={{
              style: { textAlign: "right" },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <GrassIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            fullWidth
            size="small"
            label="Ciclo"
            variant="outlined"
            name="ciclo"
            onChange={actualizarCampo}
            value={stateCultivos.formDatos.ciclo}
          />

          <TextField
            fullWidth
            select
            size="small"
            label="Mes de Cosecha"
            variant="outlined"
            name="mescosecha"
            onChange={actualizarCampo}
            value={stateCultivos.formDatos.mescosecha}
          >
            <MenuItem key={"1"} value="01">
              ENERO
            </MenuItem>
            <MenuItem key={"2"} value="02">
              FEBRERO
            </MenuItem>
            <MenuItem key={"3"} value="03">
              MARZO
            </MenuItem>
            <MenuItem key={"4"} value="04">
              ABRIL
            </MenuItem>
            <MenuItem key={"5"} value="05">
              MAYO
            </MenuItem>
            <MenuItem key={"6"} value="06">
              JUNIO
            </MenuItem>
            <MenuItem key={"7"} value="07">
              JULIO
            </MenuItem>
            <MenuItem key={"8"} value="08">
              AGOSTO
            </MenuItem>
            <MenuItem key={"9"} value="09">
              SEPTIEMBRE
            </MenuItem>
            <MenuItem key={"10"} value="10">
              OCTUBRE
            </MenuItem>
            <MenuItem key={"11"} value="11">
              NOVIEMBRE
            </MenuItem>
            <MenuItem key={"12"} value="12">
              DICIEMBRE
            </MenuItem>
          </TextField>
          <TextField
            type="text"
            fullWidth
            size="small"
            label="Precio"
            variant="outlined"
            name="precio"
            id="precio"
            // onFocus={onFocus}
            // onBlur={onBlur}
            onChange={actualizarCampo}
            onKeyUp={(input) => Moneda(input.target)}
            value={stateCultivos.formDatos.precio}
            inputProps={{
              style: { textAlign: "right" },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoneyIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
          <div className="mid">
            <TextField
              fullWidth
              select
              size="small"
              label="Tipo de Riego"
              name="tipo_riego"
              variant="outlined"
              onChange={actualizarCampo}
              value={stateCultivos.formDatos.tipo_riego}
            >
              <MenuItem key={"B"} value="B">
                BOMBEO
              </MenuItem>
              <MenuItem key={"G"} value="G">
                GOTEO
              </MenuItem>
              <MenuItem key={"R"} value="R">
                RODADO
              </MenuItem>
            </TextField>
            <TextField
              select
              fullWidth
              size="small"
              label="Temporal"
              variant="outlined"
              name="temporal"
              onChange={actualizarCampo}
              value={stateCultivos.formDatos.temporal}
            >
              <MenuItem key={"S"} value="S">
                SI
              </MenuItem>
              <MenuItem key={"N"} value="N">
                NO
              </MenuItem>
            </TextField>
            <TextField
              select
              fullWidth
              size="small"
              label="Seguro de Cosecha"
              variant="outlined"
              name="seguro_cosecha"
              onChange={actualizarCampo}
              value={stateCultivos.formDatos.seguro_cosecha}
            >
              <MenuItem key={"S"} value="S">
                SI
              </MenuItem>
              <MenuItem key={"N"} value="N">
                NO
              </MenuItem>
              <MenuItem key={"C"} value="C">
                COMPAÑIA
              </MenuItem>
            </TextField>
            <TextField
              select
              fullWidth
              size="small"
              label="Terreno"
              variant="outlined"
              name="terreno"
              onChange={actualizarCampo}
              value={stateCultivos.formDatos.terreno}
            >
              <MenuItem key={"P"} value="P">
                PROPIO
              </MenuItem>
              <MenuItem key={"R"} value="R">
                RENTADO
              </MenuItem>
              <MenuItem key={"E"} value="E">
                EJIDAL
              </MenuItem>
              <MenuItem key={"S"} value="S">
                SOCIEDAD
              </MenuItem>
            </TextField>
            {/* <TextField
              type="text"
              fullWidth
              size="small"
              label="PRECIO"
              variant="outlined"
              name="precio"
              id="precio"
              onChange={actualizarCampo}
              // onBlur={onBlur}
              // onFocus={onFocus}
              inputProps={{
                style: { textAlign: "right" },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachMoneyIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            /> */}
          </div>
          <div className="mid dash-clientes-credito-crear-solicitud-modal-button-container">
            <Button onClick={closeModal} variant="contained" color="error">
              Cerrar
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                agregarCultivo(stateCultivos.formDatos);
              }}
            >
              {stateCultivos.formDatos.idsolicitud_cultivo === -1
                ? "Agregar"
                : "Editar"}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
